import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { logEventGA4, migrateReduxSessionStorageFilterValue, sessionStorageMF, setFilterValue } from '@medifind/zustand';

const initialState = {
  name: 'trialRadius',
  type: 'singleSelect',
  selected: { display: 'Global', value: 'global', fidelity: 6 },
};

const storeName = 'trialRadius';
export const useTrialRadiusFilter = create(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        set,
        reset: () => set({ ...initialState }, false, { type: 'reset' }),
        getInitialState: () => ({ ...initialState }),
        setFilterValue: (v) => updateTrialRadiusFilter(v),
      }),
      {
        name: `${process.env.NX_APP}-${storeName}`,
        version: 0,
        storage: createJSONStorage(() => sessionStorageMF),
        onRehydrateStorage: () => (state) => {
          migrateReduxSessionStorageFilterValue({ state, key: 'trialRadius' });
        },
      },
    ),
    {
      name: `${process.env.NX_APP}`,
      store: storeName,
    },
  ),
);

export const updateTrialRadiusFilter = (option) => {
  if (option && process.env.NX_APP === 'MediFind-Pro') {
    const { value } = option;
    logEventGA4('filter', { type: 'trial_radius', action: 'select', item_id: value }, '28ce06ac-e187-440f-b96f-d250bb014212');
  }
  setFilterValue(useTrialRadiusFilter, option);
};

export const clearTrialRadiusFilter = () =>
  useTrialRadiusFilter.setState({ ...initialState }, false, {
    type: 'clearTrialRadiusFilter',
  });
